const Ajv = require("ajv");
const { CardSchema } = require("../schema/card.model");
const { PaymentIntentSchema } = require("../schema/payment-intent.model");

const ajv = new Ajv({ allErrors: true });

const validateCardSchema = (payload) => {
  if (payload.private_label && !payload.brand) {
    return new Error("If private_label is true, brand is required!");
  }

  const isValid = ajv.validate(CardSchema, payload);

  if (!isValid) {
    return new Error(ajv.errorsText(ajv.errors));
  }
  return payload;
};

const validatePaymentIntentSchema = (payload) => {
  const isValid = ajv.validate(PaymentIntentSchema, payload);

  if (!isValid) {
    return new Error(ajv.errorsText(ajv.errors));
  }
  return payload;
};

module.exports = {
  validateCardSchema,
  validatePaymentIntentSchema,
};